/** Arabic-first i18n (Blueprint DR-13). Default locale: ar. */

type Locale = 'ar' | 'en';

const STRINGS: Record<string, Record<Locale, string>> = {
  loading_world: { ar: 'جارٍ تحميل المدينة…', en: 'Loading the city…' },
  ready: { ar: 'جاهز!', en: 'Ready!' },
  enter_lesson: { ar: 'ادخل الدرس', en: 'Enter lesson' },
  locked_building: { ar: 'مغلق', en: 'Locked' },
  talk_to_eva: { ar: 'تحدث مع إيفا', en: 'Talk to EVA' },
  lesson_title: { ar: 'درس — Theatrix', en: 'Lesson — Theatrix' },
  close: { ar: 'إغلاق', en: 'Close' },
  xp_gain: { ar: '+{0} نقطة خبرة', en: '+{0} XP' },
  level_label: { ar: 'المستوى {0}', en: 'Level {0}' },
  interact_hint: { ar: '[E] {0}', en: '[E] {0}' },
  map_title_initial: { ar: 'اختر نقطة النزول', en: 'Choose your drop point' },
  map_title_travel: { ar: 'السفر السريع', en: 'Fast travel' },
  map_hint_unvisited: { ar: 'امشِ إليها أولًا لتُفتح للسفر السريع', en: 'Walk there first to unlock fast travel' },
  map_hint_visited: { ar: 'اضغط للسفر الفوري', en: 'Tap to travel instantly' },
  map_button: { ar: 'الخريطة', en: 'Map' },
  view_first: { ar: 'المنظور: أول', en: 'View: 1st' },
  view_third: { ar: 'المنظور: ثالث', en: 'View: 3rd' },
  view_heli: { ar: 'المنظور: جوي', en: 'View: heli' },
  help_button: { ar: '؟', en: '?' },
  controls_title: { ar: 'التحكم', en: 'Controls' },
  ctrl_move: { ar: 'التحرك: WASD / الأسهم / عصا اللمس', en: 'Move: WASD / arrows / joystick' },
  ctrl_look: { ar: 'النظر: اسحب بالفأرة أو المس يمين الشاشة', en: 'Look: drag mouse / right side of screen' },
  ctrl_sprint: { ar: 'الجري: Shift', en: 'Sprint: Shift' },
  ctrl_interact: { ar: 'التفاعل: E', en: 'Interact: E' },
  ctrl_map: { ar: 'الخريطة: M', en: 'Map: M' },
  ctrl_view: { ar: 'تبديل المنظور: V (أول ← ثالث ← جوي)', en: 'Switch view: V (1st → 3rd → heli)' },
  ctrl_zoom: { ar: 'الزووم: عجلة الفأرة أو أزرار ±', en: 'Zoom: mouse wheel or ± buttons' },
  obj_lesson: { ar: '🎯 الهدف: ادخل مدرستك وخذ درسًا', en: '🎯 Goal: enter your school and take a lesson' },
  obj_house: { ar: '🏠 الهدف: منزلك تطوّر! شاهده في الحي السكني', en: '🏠 Goal: your house upgraded! See it in the residential district' },
  obj_explore: { ar: '🧭 الهدف: افتح بقية الأحياء بالسير إليها', en: '🧭 Goal: unlock the remaining districts by walking to them' },
  obj_done: { ar: '🎉 أحسنت! المدينة كلها مفتوحة لك', en: '🎉 Well done! The whole city is yours' },
  level_up: { ar: '🎉 المستوى {0}!', en: '🎉 Level {0}!' },
  loading_tip: { ar: 'مدينة تعليمية بمبانٍ من صور حقيقية', en: 'A learning city built from real photos' },
  slice_preview_title: { ar: 'معاينة شارع Bistro', en: 'Bistro street preview' },
  slice_preview_hint: { ar: 'اسحب للدوران، عجلة الفأرة للتقريب، وWASD للمشي', en: 'Drag to orbit, scroll to zoom, WASD to walk' },
  slice_preview_walk: { ar: 'وضع المشي', en: 'Walk mode' },
  slice_preview_orbit: { ar: 'وضع الدوران', en: 'Orbit mode' },
  slice_preview_loading: { ar: 'جارٍ تحميل المشهد…', en: 'Loading scene…' },
  slice_preview_ready: { ar: 'المشهد جاهز', en: 'Scene ready' },
  slice_preview_interim: { ar: 'معاينة مرحلية: خامات وهندسة، دون إضاءة مخبوزة', en: 'Interim preview: geometry and materials, without baked lighting' },
  slice_preview_waiting: { ar: 'ننتظر تصدير المشهد؛ حدّث الصفحة بعد اكتماله', en: 'Waiting for scene export; refresh when ready' },
  slice_title: { ar: 'شارع Bistro — مقارنة المحركات', en: 'Bistro street — engine bake-off' },
  slice_loading: { ar: 'جارٍ تحميل الشارع والإضاءة المخبوزة…', en: 'Loading street and baked lighting…' },
  slice_ready: { ar: 'الشارع جاهز للمشي', en: 'Street ready to explore' },
  slice_benchmark: { ar: 'القياس جارٍ: {0} / {1} ثانية', en: 'Benchmark: {0} / {1} seconds' },
  slice_finished: { ar: 'اكتمل القياس؛ النتائج أدناه', en: 'Benchmark complete; results below' },
  slice_error: { ar: 'تعذّر تحميل المشهد: {0}', en: 'Scene load failed: {0}' },
  slice_walk: { ar: 'وضع المشي', en: 'Walk mode' },
  slice_orbit: { ar: 'وضع المعاينة', en: 'Preview mode' },
  slice_hint: { ar: 'اسحب للنظر، WASD للمشي، Shift للجري، ١–٣ للزوايا، وعجلة الفأرة للزوم', en: 'Drag to look, WASD to walk, Shift to sprint, 1–3 for views, wheel to zoom' },
  slice_view_reference: { ar: 'المرجع', en: 'Reference' },
  slice_view_cafe: { ar: 'المقهى', en: 'Café' },
  slice_view_street: { ar: 'الشارع', en: 'Street' },
  slice_views_label: { ar: 'زوايا المعاينة', en: 'Preview viewpoints' },
  slice_movement_label: { ar: 'أزرار الحركة', en: 'Movement controls' },
  slice_zoom_in: { ar: 'تقريب +', en: 'Zoom +' },
  slice_zoom_out: { ar: 'إبعاد −', en: 'Zoom −' },
  slice_credit: { ar: 'المشهد: Amazon Lumberyard Bistro / ORCA — CC BY 4.0', en: 'Scene: Amazon Lumberyard Bistro / ORCA — CC BY 4.0' },
  slice_reprint: { ar: 'أعد طباعة النتيجة', en: 'Print result again' },
};

let current: Locale = 'ar';

export function setLocale(locale: Locale): void {
  current = locale;
  document.documentElement.lang = locale;
  document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr';
}

export function t(key: string, ...args: Array<string | number>): string {
  const entry = STRINGS[key];
  let text = entry ? entry[current] : key;
  args.forEach((arg, i) => {
    text = text.replace(`{${i}}`, String(arg));
  });
  return text;
}
